import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';
import { CanAccessAppsService } from '../auth/services/can-access-apps.service';
import { TrackerService } from '../components/logging/tracker.service';
import { AddPresentationComponent } from './components/add-presentation/add-presentation.component';
import { ArtboardComponent } from './components/artboard/artboard.component';
import { HtmlEditorComponent } from './components/html-editor/html-editor.component';
import { PresentationListComponent } from './components/presentation-list/presentation-list.component';
import { WorkspaceComponent } from './components/workspace/workspace.component';
import { EditorService } from './services/editor.service';
import { ViewportComponent } from './viewport/viewport.component';
import {
  CAP_ALERTS_INTEGRATION_ID,
  companyIntegrationOpenTarget,
} from '../settings/services/integrations/integrations-company/integrations-company.routing';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.editor',
      abstract: true,
      component: ViewportComponent,
    },
    {
      name: 'apps.editor.home',
      url: '/editor',
      redirectTo: 'apps.editor.list',
    },
    {
      name: 'apps.editor.list',
      url: '/editor/list/{folderId:any}',
      params: {
        folderId: null,
      },
      component: PresentationListComponent,
    },
    {
      name: 'apps.editor.add',
      url: '/editor/add/:productId?utm_campaign&utm_source',
      params: {
        productId: '',
      },
      resolve: [
        {
          token: 'canAccessAps',
          deps: [Transition, EditorService],
          resolveFn: (transition, editorService) => {
            const productId = transition.params().productId;
            if (productId) {
              if (productId.startsWith('cap-alert')) {
                const target = companyIntegrationOpenTarget(
                  CAP_ALERTS_INTEGRATION_ID,
                );
                transition.router.stateService.go(target.state, target.params);
              } else {
                editorService.addFromProductId(productId, {
                  utm_campaign: transition.params().utm_campaign,
                  utm_source: transition.params().utm_source,
                });
              }
            } else {
              transition.abort();
              return transition.router.stateService.go('apps.editor.create');
            }
          },
        },
      ],
    },
    {
      name: 'apps.editor.create',
      url: '/editor/create?selectedDate&folderId',
      params: {
        selectedDate: null,
        folderId: null,
      },
      component: AddPresentationComponent,
      resolve: [
        {
          token: 'addPresentationData',
          deps: [Transition, EditorService, TrackerService],
          resolveFn: (transition, editorService, trackerService) => {
            if (transition.options().source !== 'url') {
              trackerService.presentationEvent('Add Presentation');
            }

            const params = transition.params();
            const folderId = params.folderId || null;

            if (folderId) {
              editorService.presentation.folderId = folderId;
            }
          },
        },
      ],
    },
    {
      name: 'apps.editor.workspace',
      url: '/editor/workspace/:presentationId?copyOf',
      abstract: true,
      component: WorkspaceComponent,
      params: {
        isLoaded: false,
        presentationId: '',
      },
      data: {
        requiresAuth: false,
      },
      resolve: [
        {
          token: 'presentationInfo',
          deps: [Transition, EditorService, CanAccessAppsService],
          resolveFn: (
            transition,
            editorService,
            canAccessAppsService: CanAccessAppsService,
          ) => {
            var signup = false;

            if (transition.params().copyOf) {
              signup = true;
            }

            return canAccessAppsService
              .canAccessApps(signup)
              .then(() => {
                if (
                  transition.params().presentationId &&
                  transition.params().presentationId !== 'new'
                ) {
                  return editorService.getPresentation(
                    transition.params().presentationId,
                  );
                } else if (transition.params().copyOf) {
                  if (transition.params().isLoaded) {
                    return editorService.presentation;
                  } else {
                    return editorService.copyTemplate(
                      transition.params().copyOf,
                    );
                  }
                } else {
                  return editorService.newPresentation();
                }
              })
              .then((presentationInfo) => {
                return presentationInfo;
              });
          },
        },
      ],
    },
    {
      name: 'apps.editor.workspace.artboard',
      url: '',
      reloadOnSearch: false,
      component: ArtboardComponent,
    },
    {
      name: 'apps.editor.workspace.htmleditor',
      url: '/htmleditor',
      reloadOnSearch: false,
      component: HtmlEditorComponent,
    },
  ],
};
